import React from "react";

export default function IconButton({ icon, onClick }) {
  return (
    <button type="button" className="icon-btn" onClick={onClick}>
      {icon}
    </button>
  );
}
